const KNOWN_KINDS = [
  'choice', 'trend_line', 'breakout', 'resistance', 'level',
  'entry_choice', 'engulfing_classification', 'order_ticket'
];

function envelope(payload) {
  return payload && payload.data && typeof payload.data === 'object' ? payload.data : payload || {};
}

function integer(value, fallback = 0) {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) ? parsed : fallback;
}

function itemReference(value = {}) {
  if (!value.type || !value.subtype) return null;
  return {
    type: String(value.type),
    subtype: String(value.subtype),
    position: Math.max(0, integer(value.position)),
    title: String(value.title || '')
  };
}

export function normalizeCatalog(payload) {
  const data = envelope(payload);
  const sections = Array.isArray(data.sections) ? data.sections : [];
  return {
    summary: {
      completedCount: Math.max(0, integer(data.summary && data.summary.completed_count)),
      total: Math.max(0, integer(data.summary && data.summary.questions_number)),
      progressPercent: Math.min(100, Math.max(0, integer(data.summary && data.summary.progress_percent))),
      completed: Boolean(data.summary && data.summary.completed),
      next: itemReference(data.summary && data.summary.next)
    },
    sections: sections.map(section => ({
      id: String(section.id || ''),
      title: String(section.title || ''),
      description: String(section.description || ''),
      items: (Array.isArray(section.items) ? section.items : []).map(normalizeCatalogItem)
    }))
  };
}

export function normalizeCatalogItem(value = {}) {
  const total = Math.max(0, integer(value.questions_number));
  const currentPosition = Math.min(Math.max(0, total - 1), Math.max(0, integer(value.current_position)));
  return {
    id: String(value.id || `${value.type || ''}-${value.subtype || ''}`),
    type: String(value.type || ''),
    subtype: String(value.subtype || ''),
    title: String(value.title || 'Ejercicio'),
    kind: KNOWN_KINDS.includes(value.kind) ? value.kind : 'choice',
    instructions: String(value.instructions || ''),
    submissionMode: value.submission_mode === 'batch' ? 'batch' : 'immediate',
    total,
    currentPosition,
    completedCount: Math.min(total, Math.max(0, integer(value.completed_count))),
    progressPercent: Math.min(100, Math.max(0, integer(value.progress_percent))),
    completed: Boolean(value.completed)
  };
}

function normalizeCandle(row = {}) {
  let time = row.date;
  if (typeof time === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(time)) {
    time = Date.parse(`${time}T00:00:00Z`);
  } else if (Number(time) < 1000000000000) {
    time = Number(time) * 1000;
  }
  return {
    date: String(row.date || ''),
    time: Number(time) || 0,
    open: Number(row.open) || 0,
    high: Number(row.high) || 0,
    low: Number(row.low) || 0,
    close: Number(row.close) || 0
  };
}

function normalizeChart(chart) {
  return Object.keys(chart && typeof chart === 'object' ? chart : {}).reduce((output, key) => {
    output[String(key)] = (Array.isArray(chart[key]) ? chart[key] : []).map(normalizeCandle);
    return output;
  }, {});
}

export function normalizeExerciseItem(payload) {
  const data = envelope(payload);
  const question = data.question || {};
  return {
    id: String(data.id || ''),
    type: String(data.type || ''),
    subtype: String(data.subtype || ''),
    title: String(data.title || 'Ejercicio'),
    instructions: String(data.instructions || ''),
    kind: KNOWN_KINDS.includes(data.kind) ? data.kind : 'choice',
    submissionMode: data.submission_mode === 'batch' ? 'batch' : 'immediate',
    position: Math.max(0, integer(data.position)),
    total: Math.max(1, integer(data.questions_number, 1)),
    question: {
      title: String(question.title || ''),
      picture: String(question.picture || ''),
      ticker: String(question.ticker || ''),
      options: (Array.isArray(question.options) ? question.options : []).map(option => ({
        value: String(option.value),
        text: String(option.text || '')
      })),
      chart: normalizeChart(question.chart)
    }
  };
}

export function normalizeAttemptResult(payload) {
  const data = envelope(payload);
  return {
    correct: data.correct === null || data.correct === undefined ? null : Boolean(data.correct),
    passed: Boolean(data.passed),
    completed: Boolean(data.completed),
    scorePercent: data.score_percent === undefined ? null : integer(data.score_percent),
    nextPosition: Math.max(0, integer(data.next_position)),
    feedback: String(data.feedback || ''),
    review: (Array.isArray(data.review) ? data.review : []).map(row => ({
      position: Math.max(0, integer(row.position)),
      title: String(row.title || ''),
      correctOption: row.correct_option ? {
        value: String(row.correct_option.value),
        text: String(row.correct_option.text || '')
      } : null
    }))
  };
}
